import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../auth/auth.service';
import { map } from 'rxjs';

export const authGuard = () => {
  const router = inject(Router);
  const auth = inject(AuthService);

  return auth.auth$.pipe(
    map((auth) => {
      if (!auth) {
        router.navigate(['/login']);
        return false;
      }

      return true;
    }),
  );
};
